import { LOCATION_CHANGE } from 'react-router-redux';

import * as organizationConstants from '../constants/organizations';
import * as bucketConstants from '../constants/buckets';

const initialOrganizationBucketsFilterState = {
    bucketName: '',
    selectedApplicationsIds: undefined,
};

export function organizationBucketsFilter(
    state = initialOrganizationBucketsFilterState,
    action,
) {
    switch (action.type) {
        case LOCATION_CHANGE:
            // on url change reset params
            return {
                ...initialOrganizationBucketsFilterState,
            };
        case organizationConstants.CHANGE_ORGANIZATION_BUCKETS_SEARCH:
            return {
                ...state,
                bucketName: action.payload,
            };
        default:
            return state;
    }
}

export function organizationMembersFilter(state = { searchTerm: '' }, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
        case organizationConstants.TOGGLE_ADD_MEMBER:
            // on url change reset params
            return {
                searchTerm: '',
            };
        case organizationConstants.CHANGE_ORGANIZATION_MEMBERS_FILTER:
            return {
                ...state,
                searchTerm: action.payload,
            };
        default:
            return state;
    }
}

export function bucketMembersFilter(state = { searchTerm: '' }, action) {
    switch (action.type) {
        // on url change, or when adding member, reset params
        case LOCATION_CHANGE:
        case bucketConstants.TOGGLE_ADD_MEMBER:
            return {
                searchTerm: '',
            };
        case bucketConstants.CHANGE_BUCKET_MEMBERS_FILTER:
            return {
                ...state,
                searchTerm: action.payload,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/filterReducer.js